
import axios from 'axios';
import authHeader from './auth-header'; // Asegúrate de que esto esté configurado

const API_URL = process.env.VUE_APP_API_BASE_URL;

export default {
    getAll(data=null) {
        const queryString = new URLSearchParams(data).toString();
        const url = `${API_URL}/purchases?${queryString}`; 
        return axios.get(url, { headers: authHeader() });
    },
    getData(id) {
        return axios.get(`${API_URL}/purchases/${id}`, { headers: authHeader() });
    },
    createData(data) {

        // Obtener el user_id desde el localStorage
        let userId = JSON.parse(localStorage.getItem('user'));

        // Validar el user_id
        if (!userId || !userId.id) {
            throw new Error("User ID no válido. Asegúrate de haber iniciado sesión.");
        }

        data.user_id = userId.id;
        
        return axios.post(`${API_URL}/purchases`, data, { headers: authHeader() });
    },
    updateData(id, data) {
        return axios.put(`${API_URL}/purchases/${id}`, data, { headers: authHeader() });
    },
    deleteData(id) {
        return axios.delete(`${API_URL}/purchases/${id}`, { headers: authHeader() });
    },
    detailSave(data) {
        return axios.post(`${API_URL}/purchases-details`, data, { headers: authHeader() });
    },
    getDoc(id) {
        return axios.get(`${API_URL}/purchases/export/${id}`, { headers: authHeader(), responseType: 'blob' });
    },
    exportData(filters = {}) {
        return axios.post(`${API_URL}/export/purchases`, filters, { 
            headers: authHeader(),
            responseType: 'blob' // Importante para descargar archivos
        });
    },
};